<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="admin-account-form page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button type="text"
                   icon="el-icon-back"
                   class="back-button"
                   @click.prevent="backToAdminAccountList">
        </el-button>
        <h2 class="page-title">{{ isUpdated ? 'แก้ไขบัญชีผู้ดูแล' : 'เพิ่มบัญชีผู้ดูแล' }}</h2>
      </el-col>
    </el-row>

    <el-form
      :model="adminForm"
      :rules="adminFormRules"
      ref="adminForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('adminForm')"
      :disabled="isSubmitting"
      class="admin-form">
      <el-row>
        <el-col :span="9">
          <el-form-item label="อีเมลผู้ดูแล" prop="email">
            <el-input
              v-model="adminForm.email"
              :disabled="isViewerRole"
              id="adminForm.email"
              placeholder="กรอกอีเมลผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item label="ชื่อผู้ดูแล" prop="name">
            <el-input
              v-model="adminForm.name"
              :disabled="isViewerRole"
              id="adminForm.name"
              placeholder="กรอกชื่อผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item label="รหัสพนักงานของธนาคาร" prop="scb_employee_id">
            <el-input
              v-model="adminForm.scb_employee_id"
              :disabled="isViewerRole"
              id="adminForm.scb_employee_id"
              ref="adminForm.scb_employee_id"
              @input.native="handleInput($event, 'adminForm.scb_employee_id', 'scb_employee_id')"
              placeholder="กรอกรหัสพนักงานของธนาคาร"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item label="หมายเลขโทรศัพท์" prop="tel">
            <el-input
              v-model="adminForm.tel"
              :disabled="isViewerRole"
              id="adminForm.tel"
              placeholder="กรอกหมายเลขโทรศัพท์"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item label="หน้าที่ผู้ดูแล" prop="role">
            <!--<el-select
              v-model="adminForm.role"
              :disabled="isViewerRole"
              id="adminForm.role">
              <el-option
                v-for="role in roleList"
                :key="role.value"
                :label="role.label"
                :value="role.value">
              </el-option>
            </el-select>-->
            <el-radio-group v-model="adminForm.role" :disabled="isViewerRole">
              <el-radio
                v-for="role in roleList"
                :key="role.value"
                :label="role.value">{{ role.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item label="สถานะบัญชี" prop="status">
            <el-checkbox
              v-model="adminForm.status"
              :disabled="isViewerRole"
              class="status-holder"
              :class="{hide: isViewerRole}"
              id="adminForm.status">สถานะการใช้งาน (Flag = Enable, Not Flag = Disable/Blocked)</el-checkbox>
            <div class="user-status" v-if="isViewerRole">
              <el-tag
                :type="statusTypeFormatter(adminForm.status)"
                close-transition>{{statusFormatter(adminForm.status)}}</el-tag>
            </div>
            <div class="blocked-status-section" v-if="isBlocked && isViewerRole">
              <el-button
                plain
                type="primary"
                id="unblock-button"
                @click="unblockUser">ปลดล็อคบัญชีผู้ดูแลบริษัท</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="รายละเอียดผู้ดูแล" prop="description">
            <el-input
              v-model="adminForm.description"
              :disabled="isViewerRole"
              id="adminForm.description"
              placeholder="กรอกรายละเอียดผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item class="button-bar">
            <el-button
              type="primary"
              plain
              class="cancel-btn"
              @click="backToAdminAccountList"
              id="adminForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
            <div class="submit-button-group" v-if="!isViewerRole">
              <el-button
                type="danger"
                class="terminate-btn"
                icon="el-icon-delete"
                v-if="isUpdated"
                @click="confirmTerminate"
                id="adminForm.terminateButton">{{ 'Terminate' | translate }}</el-button>
              <el-button
                type="primary"
                id="adminForm.submitButton"
                native-type="submit">{{ isUpdated ? 'แก้ไขบัญชี' : 'สร้างบัญชี' }}</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  import helpers from '@/libs/helpers';
  import _ from 'lodash';
  import { createMask } from 'imask';
  /**
   * AdminAccount Form view
   */
  const AdminAccountFormView = {
    name: 'account-form',
    props: ['adminId'],
    data() {
      return {
        isSubmitting: false,
        isSetupUpdateData: false,
        roleList: [
          { label: 'SCB Admin', value: 'ADMIN' },
          { label: 'SCB Viewer', value: 'VIEWER' },
        ],
        adminForm: {
          // auth_user_id: '',
          email: '',
          name: '',
          scb_employee_id: '',
          tel: '',
          status: true,
          description: '',
          role: 'viewer', // should change to viewer
          // created_at: '',
          // update_at: '',
        },
        isBlocked: false,
        adminFormRules: {
          email: [
            { required: true, message: 'กรุณากรอกอีเมลผู้ดูแล', trigger: 'blur' },
            { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' },
          ],
          name: [
            { required: true, message: 'กรุณากรอกชื่อผู้ดูแล', trigger: 'blur' },
          ],
          scb_employee_id: [
            { type: 'string', max: 6, required: true, message: 'กรุณากรอกรหัสพนักงานของธนาคาร', trigger: 'blur' },
          ],
          tel: [
            { required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' },
          ],
          /* description: [
            { required: true, message: 'กรุณากรอกรายละเอียดผู้ดูแล', trigger: 'blur' },
          ], */
        },
        mask: {
          tel: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
              { mask: '{0}00-000-0000' },
            ],
          },
          scb_employee_id: {
            mask: '000000',
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isViewerRole() {
        return this.$store.getters.isViewerRole;
      },
      isUpdated() {
        return typeof this.adminId !== 'undefined';
      },
      adminInfo() {
        if (this.isUpdated) {
          let adminInfo = null;
          this.$store.getters.adminList.forEach((item) => {
            if (item.id === this.adminId) {
              adminInfo = item;
            }
          });
          return adminInfo;
        }
        return null;
      },
    },
    methods: {
      backToAdminAccountList() {
        this.$router.push({ name: 'AdminAccountList' });
      },
      confirmTerminate() {
        this.$confirm('ท่านกำลังจะลบบัญชีผู้ดูแลนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
          confirmButtonText: this.$t('Confirm'),
          confirmButtonClass: 'danger-btn',
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.isSubmitting = true;
          this.$store.dispatch('DELETE_ADMIN_USER', this.adminId).then(() => {
            this.isSubmitting = false;
            this.$message({
              type: 'success',
              showClose: true,
              duration: 10000,
              message: 'ลบข้อมูลผู้ดูแลสำเร็จแล้ว',
            });
            this.backToAdminAccountList();
          }).catch((msg) => {
            this.isSubmitting = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
          });
        }).catch(() => {
        });
      },
      unblockUser() {
        this.$confirm('ท่านกำลังจะปลดล็อคบัญชีผู้ดูแลนี้ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
          confirmButtonText: this.$t('Confirm'),
          // confirmButtonClass: 'danger-btn',
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.isSubmitting = true;
          this.$store.dispatch('UNBLOCK_ADMIN_USER', this.adminId).then(() => {
            this.isSubmitting = false;
            this.$message({
              type: 'success',
              showClose: true,
              duration: 10000,
              message: 'ปลดล็อคบัญชีผู้ดูแลสำเร็จแล้ว',
            });
            this.backToAdminAccountList();
          }).catch((msg) => {
            this.isSubmitting = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
          });
        }).catch(() => {
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate(this.validateForm);
      },
      validateForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        this.isSubmitting = true;
        const action = this.isUpdated ? 'UPDATE_ADMIN_USER' : 'CREATE_ADMIN_USER';
        const payload = JSON.parse(JSON.stringify(this.adminForm));
        // transform payload's status
        payload.status = payload.status ? 'active' : 'inactive';
        // this.unmaskValue(payload, 'tel', this.mask.tel);
        delete payload.created_at;
        delete payload.update_at;
        this.$store.dispatch(action, payload).then(() => {
          this.isSubmitting = false;

          let successMessage = 'สร้างบัญชีผู้ดูแลใหม่สำเร็จแล้ว';
          if (this.isUpdated) {
            successMessage = 'แก้ไขข้อมูลบัญชีผู้ดูแลสำเร็จแล้ว';
          }
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: successMessage,
          });
          this.backToAdminAccountList();
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      setupUpdateData() {
        if (typeof this.adminInfo !== 'undefined' && this.adminInfo) {
          this.isSetupUpdateData = true;
          Object.keys(this.adminInfo).forEach((key) => {
            if (key === 'status') {
              const isActive = this.adminInfo[key] === 'active';
              this.isBlocked = this.adminInfo[key] === 'blocked';
              this.$set(this.adminForm, key, isActive);
            } else {
              this.$set(this.adminForm, key, this.adminInfo[key]);
            }
          });
          // this.isBlocked = true; // -- For testing unblock
        }
      },
      clearUpdateData() {
        this.isSetupUpdateData = false;
        this.isBlocked = false;
        this.adminForm.email = '';
        this.adminForm.name = '';
        this.adminForm.scb_employee_id = '';
        this.adminForm.tel = '';
        this.adminForm.status = true;
        this.adminForm.description = '';
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* updateMaskTel() {
        try {
          this.maskValue(this.adminForm, 'tel', this.mask.tel);
        } catch (e) {
          console.error(e);
        }
      }, */
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        helpers.handleInput(evt,
          this.$refs, refName,
          this.mask, maskName);
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
      statusFormatter(status) {
        let statusText = 'Disabled';
        if (this.isBlocked) {
          statusText = 'Blocked';
        } else if (status) {
          statusText = 'Enabled';
        }
        return statusText;
      },
      statusTypeFormatter(status) {
        let type = 'info';
        if (this.isBlocked) {
          type = 'danger';
        } else if (status) {
          type = 'success';
        }
        return type;
      },
    },
    mounted() {
      // load data to form
      if (this.isUpdated) {
        setTimeout(() => {
          if (typeof this.adminInfo === 'undefined' || this.adminInfo === null) {
            this.backToAdminAccountList();
          }
        }, 1000);
      }
      if (this.isUpdated && this.adminInfo) {
        this.$nextTick(() => {
          this.setupUpdateData();
        });
      }
    },
    watch: {
      adminInfo(newVal) {
        if (this.isUpdated && !this.isSetupUpdateData && newVal) {
          this.$nextTick(() => {
            this.setupUpdateData();
          });
        }
      },
    },
    beforeRouterLeave(to, from, next) {
      this.clearUpdateData();
      next();
    },
  };
  export default AdminAccountFormView;
</script>

<style lang="scss">
  .admin-form {
    .cancel-btn, .terminate-btn {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .submit-button-group {
      float: right;
    }
    .status-holder {
      &.hide {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/admin-account-form.vue